export default "__VITE_ASSET__ff768122__"